<template>
  <div v-cloak>
    <div v-show="imgFlag" class="relative">
      <video-player
        class="vjs-custom-skin"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="playsinline"
        @play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"
        @ended="onPlayerEnded($event)"
        @loadeddata="onPlayerLoadeddata($event)"
        @waiting="onPlayerWaiting($event)"
        @playing="onPlayerPlaying($event)"
        @timeupdate="onPlayerTimeupdate($event)"
        @canplay="onPlayerCanplay($event)"
        @canplaythrough="onPlayerCanplaythrough($event)"
        @ready="playerReadied"
        @statechanged="playerStateChanged($event)"
      >
      </video-player>
    </div>
    <p
      @click="play"
      v-show="zdyplay"
      id="play"
      :style="{ display: videoSrc == null ? 'none' : 'block' }"
    ></p>
  </div>
</template>

<script>
import {
  addUserVideoStatusAndLog,
  StorageTime,
} from "@/model/learn/learnServer";

export default {
  data() {
    return {
      zdyplay: true,
      videoSrc: "",
      time: 0,
      maxTime: 0,
      num: 0,
    };
  },
  props: {
    gid: {
      type: Number,
    },
    cid: {
      type: Number,
    },
    vid: {
      type: Number,
    },
    imgFlag: {
      type: Boolean,
      default: true,
    },
    timer: {
      type: Number,
      default: 0,
    },
    playerOptions: {
      type: Object,
      default() {
        return {
          height: document.body.clientWidth,
          width: document.body.clientWidth,
          autoplay: false,
          muted: true,
          language: "en",
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [
            {
              type: "video/mp4",
              src: "http://webxiaozhu.oss-cn-beijing.aliyuncs.com/Course/%E4%BF%AE%E6%94%B9%E5%90%8E02-%E7%8E%B0%E5%9C%A8%E4%B8%8D%E5%AD%A6BIM%E5%B0%86%E6%9D%A5%E5%8F%91%E5%B1%95%E5%A5%BD%E5%90%97.mp4",
            },
          ],
          poster:
            "https://webxiaozhu.oss-cn-beijing.aliyuncs.com/images/video.jpg",
        };
      },
    },
    details: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    player() {
      if (this.$refs.videoPlayer == undefined) return false;
      return this.$refs.videoPlayer.player;
    },
    playsinline() {
      let ua = navigator.userAgent.toLocaleLowerCase();
      // x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        return false;
      } else {
        // ios端
        return true;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.player.muted(false);
    }, 5000);
  },
  methods: {
    showVideo(e, m) {
      let myPlayer = this.$refs.videoPlayer.player;
      myPlayer.poster(m);
      myPlayer.src(e);
      this.videoSrc = e;
    },
    onPlayerPlay(player) {
      this.$emit("onPlayerPlay", player);
      if (this.num == 0) {
        if (this.timer > 0)
          this.playerReadied(this.$refs.videoPlayer.player, this.timer);
        let data = {
          cid: this.cid,
          gid: this.gid,
          vid: this.vid,
          uid: this.uid(),
        };
        StorageTime(data).then((res) => {
          this.num += 1;
          console.log(res);
        });
      }
    },
    onPlayerPause() {
      console.log("暂停");
      // player
    },
    onPlayerEnded() {
      // player
    },
    onPlayerLoadeddata() {
      // player
    },
    onPlayerWaiting() {
      // player
    },
    onPlayerPlaying() {
      if (this.videoSrc == null) {
        this.onPlayerPause();
        return false;
      }
      // player
    },
    onPlayerTimeupdate(player) {
      // 获取视频播放进度
      // player
      this.time = player.cache_.currentTime;
      if (this.time > this.maxTime) this.maxTime = this.time;
    },
    onPlayerCanplay() {
      //player
    },
    onPlayerCanplaythrough() {
      //player
    },
    // or listen state event
    playerStateChanged() {
      // playerCurrentState
    },
    // player is ready
    playerReadied(player, val) {
      // 设置视频播放点
      player.currentTime(val);
    },
    play() {
      this.player.play();
      this.zdyplay = false;
    },
    addUserVideoStatusAndLog() {
      if (this.maxTime <= 60) return false;
      let data = {
        uid: this.uid(),
        cid: this.cid,
        gid: this.gid,
        vid: this.vid,
        videoprogress: this.maxTime,
      };
      addUserVideoStatusAndLog(data).then((res) => {
        console.log(res);
      });
    },
  },
  destroyed() {
    window.removeEventListener("beforeunload", (e) =>
      this.addUserVideoStatusAndLog(e)
    );
  }, 
  // watch:{
  //   time:{
  //     deep:true,
  //     immediate:true,
  //     handler(val){
        
  //       this.$nextTick(() => {
  //         if(val > 0 && val < 5) {
  //           this.playerReadied(this.$refs.videoPlayer.player, 5);
  //         }
  //       })
        
  //     }
  //   }
  // }
};
</script>
<style lang="less" scoped>
.imgbox {
  width: 100%;
  height: 210/20rem;
}
#play {
  position: absolute;
  width: 100%;
  height: 210/20rem;
  top: 0;
  z-index: 1;
}
</style>
